// Công pháp chủ tu (CULTIVATION §6.3). P0 chỉ có công pháp mở đầu Đăng Linh dạy.
import type { BALANCE } from '../balance';
import type { Element } from '../elements';
import type { Phase } from '../screens';

export type TechniqueGrade = keyof typeof BALANCE.TECHNIQUE_GRADE_MULT;
export interface TriOrigin {
  body: number;
  spirit: number;
  mind: number;
}

/** Đặc hiệu tầng 3 / 6 / 9 dạng data; P0 chỉ có loại nhân Tâm Đắc. */
export type LayerPerkEffect = { readonly kind: 'masteryMult'; readonly value: number };

export interface TechniqueDef {
  readonly id: string;
  readonly grade: TechniqueGrade;
  readonly element: Element | null;
  readonly ratio: TriOrigin;
  readonly layerPerks: readonly { readonly layer: 3 | 6 | 9; readonly effect: LayerPerkEffect }[];
  readonly source: 'start' | 'library' | 'inheritance' | 'relic' | 'kyNgo' | 'faction';
  readonly phase: Phase;
}

export const TECHNIQUES: readonly TechniqueDef[] = [
  {
    id: 'tech.qiGuiding',
    grade: 'hoang',
    element: null,
    ratio: { body: 1, spirit: 1, mind: 1 },
    layerPerks: [{ layer: 3, effect: { kind: 'masteryMult', value: 0.1 } }],
    source: 'start',
    phase: 'P0',
  },
];

export const START_TECHNIQUE_ID = 'tech.qiGuiding';
/** Số tầng của mọi công pháp chủ tu (CULTIVATION §6.1). */
export const TECHNIQUE_MAX_LAYER = 9;

export function techniqueDef(id: string): TechniqueDef {
  const d = TECHNIQUES.find((x) => x.id === id);
  if (!d) throw new RangeError(`unknown technique: ${id}`);
  return d;
}

export function isTechniqueId(v: unknown): v is string {
  return typeof v === 'string' && TECHNIQUES.some((x) => x.id === v);
}
